<section>
    <button on:click={newSession}>New session</button>
    <div class="version">Frontend version: <span>{$version.frontend}</span></div>
    <div class="version">Backend version: <span>{$version.backend}</span></div>
</section>

<style>
section {
    border-top: 3px dashed var(--kilo);
    margin-top: 30px;
    padding-top: 30px;
    padding-bottom: 30px;
    position: relative;
}
button {
    margin: 10px;
}
.version {
    padding: 10px;
    float: right;
	font-family: 'Josefin Sans', sans-serif;
    font-weight: 600;
    font-size: 1em;
}
.version span {
    border: 1px solid var(--kilo);
    background-color: var(--mega);
    padding: 10px;
}
</style>

<script>
import { version, profile } from "../stores/index"

export let socket

const newSession = () => {
    if (!confirm(`Are you stuck?`)) return;
	socket.emit("new-session")
	document.location = './'
}
</script>